import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalTypesComponent } from 'src/app/components/shared/modals-types/modal-types.component';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { FunctionsService, HttpService, LocalStorageService, MessageService, params, SessionService, TableColumns, TableConfiguration } from 'brainloper-ui';
import { InputOrOutputInventory } from 'src/app/models/inventory/input-or-output-inventory';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { User } from 'src/app/models/administration/user';
import { Item } from 'src/app/models/inventory/item';
import { Provider } from 'src/app/models/administration/provider';
import { ItemComboLength } from 'src/app/models/inventory/item-combo-length';
import { Warehouse } from 'src/app/models/inventory/warehouse';
import { enumWorkOrderStates, WorkOrder } from 'src/app/models/maintenance/work-order';
import { PurchaseOrder } from 'src/app/models/inventory/purchase-order';
import { RentalOrder } from 'src/app/models/rental/rental-order';
import { HandlerItemsService } from './handler-items.service';
import { HandlerItemsHeaderConfig } from './handler-items-header/handler-items-header.component';
import { HandlerItemsRowConfig } from './handler-items-row/handler-items-row.component';

export enum HandlerItemsSource {
  INPUTS = 'inputs',
  OUTPUTS = 'outputs',
  PURCHASE_ORDER = 'purchase_order',
  RENTAL_ORDER = 'rental_order',
  GENERAL = 'general',
}

@Component({
  selector: 'app-handler-items',
  templateUrl: './handler-items.component.html',
  styleUrls: ['./handler-items.component.scss'],
  providers: [HandlerItemsService],
  standalone: false
})
export class HandlerItemsComponent implements OnInit, OnChanges {

  @Input() addNewItem: boolean = false
  @Input() addProvider: boolean = false
  @Input() addWarehouse: boolean = true
  @Input() addRentalOrder: boolean = false
  @Input() comboWorkOrder: boolean = false
  @Input() showDate: boolean = true
  @Input() showTotal: boolean = true
  @Input() showAmount: boolean = true
  @Input() openDialog: boolean = true
  @Input() showReplyButton: boolean = true
  @Input() showPrintButton: boolean = false
  @Input() showCurrentAmount: boolean = true
  @Input() showUnitMeasurement: boolean = true
  @Input() showPurchaseOrder: boolean = false
  @Input() showAddItemButton: boolean = true
  @Input() showRemoveItemButton: boolean = true
  @Input() labelCodigo: string = 'Código'
  @Input() titleDialog: string = ''
  @Input() addCurrentAmount: boolean = false
  @Input() replyRoute: string = null
  @Input() headerDetails: boolean = true
  @Input() acceptButton: boolean = false
  @Input() labelAcceptButton: string = 'Aceptar'
  @Input() itemsData: Array<InputOrOutputInventory> = [];
  @Input() workOrderData: WorkOrder = {};
  @Input() editHistoryInventory: HistoryInventory
  @Input() addReceptionDate: boolean = false
  @Input() addAuthorize: boolean = false
  @Input() editCostItem: boolean = false
  @Input() initializeEmptyItem: boolean = false
  @Input() urlItemCombo: string = ""
  @Input() fromPackOff: boolean = false
  @Input() workOrderState: enumWorkOrderStates = enumWorkOrderStates.IN_EXECUTION
  @Input() view: boolean = true
  @Input() paramsWarehouse: params[] = [{ id: 'active', value: 1 }];
  @Input() paramsRentalOrder: params[] = [];
  @Input() rentalorderId: number = null
  @Input() showDeleteItem: boolean = true
  @Input() showTargetWarehouse: boolean = false
  @Input() source: HandlerItemsSource = HandlerItemsSource.GENERAL

  @Output() listItemComplete = new EventEmitter<HistoryInventory>()
  @Output() comboItemLength = new EventEmitter<ItemComboLength>()
  @Output() goBackButton = new EventEmitter<true>()
  @Output() printButton = new EventEmitter<number>()

  public today: string
  public providerId: number = -1
  public warehouseId: number = -1
  public destinationWarehouseId: number = -1
  public purchaseOrderId: number = null
  public currentUser: number = 0
  public userAuthorizeId: number = 0
  public total: number = -1
  public labels = ['Total: $ 0']
  public buttonActive: boolean = false
  public receptionDate: string | Date
  public isMobile: boolean = screen.width > 800 ? true : false;
  public workOrderId: number = null
  public showProvider: boolean = true
  public comboPurchaseOrder: boolean = true

  public comboDataWarehouse: Warehouse[] = []
  public comboDataProvider: Array<Provider> = []
  public comboDataUser: Array<User> = []
  public comboDataItems: Array<Item> = []
  public comboItemsByWarehouse: any = {}

  // Per-row version counter: incremented to signal a specific row to clear its item combo
  public reloadItemVersions: number[] = [];

  private keyUpTimeouts: Map<number, any> = new Map();

  private paramsItemsCombo: params[] = [{ id: 'warehouseId', value: 0 }]

  constructor(
    private functionEter: FunctionsService,
    private message: MessageService,
    private storage: LocalStorageService,
    public dialog: MatDialog,
    public router: Router,
    public http: HttpService,
    private session: SessionService,
    private activeRoute: ActivatedRoute,
    public handlerItemsService: HandlerItemsService
  ) {
    this.currentUser = this.storage.get<number>('userId')
    this.userAuthorizeId = this.currentUser
  }

  async ngOnInit() {
    this.message.openLoading("Cargando", "Cargando información")
    this.today = this.functionEter.dateDB(new Date())

    this.handlerItemsService.totalCost$.subscribe(total => this.total = total);
    this.handlerItemsService.totalLabels$.subscribe(labels => this.labels = labels);

    if (this.fromPackOff) {
      this.comboDataWarehouse = await this.http.getDataBody(EndpointDictionary.Warehouse.WAREHOUSE_COMBO, this.paramsWarehouse)
      this.suma()
      this.message.closeLoading()
      return
    }

    this.activeRoute.queryParamMap
      .subscribe(async (params) => {
        const warehouseId = params.get('warehouseId');
        this.setWarehouse(warehouseId != null ? parseInt(warehouseId) : null)
      })

    if (this.initializeEmptyItem == true) {
      this.initializeItemData()
    }

    this.message.closeLoading()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes) return
    if (changes['editHistoryInventory'] && this.editHistoryInventory) {
      this.initializeHistoryInventoryData()
    }
    if (changes['itemsData']) {
      this.editItems()
    }
  }

  private _cachedHeaderConfig: HandlerItemsHeaderConfig;
  get headerConfig(): HandlerItemsHeaderConfig {
    const newConfig: HandlerItemsHeaderConfig = {
      view: this.view,
      fromPackOff: this.fromPackOff,
      addWarehouse: this.addWarehouse,
      showProvider: this.showProvider,
      addProvider: this.addProvider,
      showPurchaseOrder: this.showPurchaseOrder,
      comboPurchaseOrder: this.comboPurchaseOrder,
      comboWorkOrder: this.comboWorkOrder,
      workOrderState: this.workOrderState,
      addRentalOrder: this.addRentalOrder,
      showTotal: this.showTotal,
      addAuthorize: this.addAuthorize,
      addReceptionDate: this.addReceptionDate,
      showReplyButton: this.showReplyButton,
      showPrintButton: this.showPrintButton,
      showTargetWarehouse: this.showTargetWarehouse,
      itemsData: this.itemsData,
      labels: this.labels,
      isMobile: this.isMobile,
      receptionDate: this.receptionDate,
      editHistoryInventory: this.editHistoryInventory,
      warehouseId: this.warehouseId,
      destinationWarehouseId: this.destinationWarehouseId,
      providerId: this.providerId,
      userAuthorizeId: this.userAuthorizeId,
      rentalOrderId: this.rentalorderId,
      workOrderId: this.workOrderData?.id,
      paramsWarehouse: this.paramsWarehouse,
      paramsTargetWarehouse: this.paramsWarehouse,
      paramsRentalOrder: this.paramsRentalOrder,
    };

    if (!this._cachedHeaderConfig || !this.shallowEqual(this._cachedHeaderConfig, newConfig)) {
      this._cachedHeaderConfig = newConfig;
    }
    return this._cachedHeaderConfig;
  }

  private _cachedRowConfig: HandlerItemsRowConfig;
  get rowConfig(): HandlerItemsRowConfig {
    const newConfig: HandlerItemsRowConfig = {
      fromPackOff: this.fromPackOff,
      comboDataWarehouse: this.comboDataWarehouse,
      comboItemsByWarehouse: this.comboItemsByWarehouse,
      comboDataItems: this.comboDataItems,
      view: this.view,
      addRentalOrder: this.addRentalOrder,
      addNewItem: this.addNewItem,
      showAmount: this.showAmount,
      isMobile: this.isMobile,
      showCurrentAmount: this.showCurrentAmount,
      editCostItem: this.editCostItem,
      labelCodigo: this.labelCodigo,
      showUnitMeasurement: this.showUnitMeasurement,
      showDeleteItem: this.showDeleteItem,
      itemsDataLength: this.itemsData.length,
    };

    if (!this._cachedRowConfig || !this.shallowEqual(this._cachedRowConfig, newConfig)) {
      this._cachedRowConfig = newConfig;
    }
    return this._cachedRowConfig;
  }

  private shallowEqual(obj1: any, obj2: any): boolean {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
    return true;
  }

  initializeItemData() {
    this.reloadItemVersions = [0];
    this.itemsData = [
      {
        itemInventoryId: null,
        amount: 0,
        unitMeasurement: null,
        code: null,
        costItem: null,
        totalCost: null,
        currentAmount: null
      }
    ]
  }

  initializeHistoryInventoryData() {
    if (this.addAuthorize) {
      this.userAuthorizeId = this.editHistoryInventory.authorize
    }
    if (this.addProvider) {
      this.providerId = this.editHistoryInventory.providerId
    }
    if (this.addReceptionDate) {
      this.receptionDate = new Date(this.editHistoryInventory.receptionDate) as Date
    }
    this.itemsData = this.editHistoryInventory.items
    this.editItems()
  }

  async editItems() {
    if (this.itemsData.length == 0) {
      this.initializeItemData()
      return
    }
    if (this.itemsData[0]?.itemInventoryId) {
      this.reloadItemVersions = new Array(this.itemsData.length).fill(0);

      for (let [index, item] of this.itemsData.entries()) {
        if (item.warehouseId && !this.comboItemsByWarehouse[item.warehouseId.toString()]) {
          this.paramsItemsCombo[0].value = item.warehouseId
          const itemsW: Item[] = await this.http.getDataBody(this.urlItemCombo, this.paramsItemsCombo);
          this.comboItemsByWarehouse[item.warehouseId.toString()] = itemsW
        }
        this.keyUpAmout(index, true)
      }
    }
    this.message.closeLoading()
  }

  async valueIDItem($event: number, index: number) {
    let existingItem = this.itemsData.find(x => x.itemInventoryId == $event)
    if (!this.fromPackOff && existingItem) {
      this.message.Warning("Advertencia", "Item ya seleccionado")
      this.deleteItemsData(index)
      return
    }

    let existingItemByWarehouse = this.itemsData.find(x => x.itemInventoryId == $event && x.warehouseId == this.itemsData[index].warehouseId);
    if (this.fromPackOff && existingItemByWarehouse) {
      this.message.Warning("Advertencia", "Item y Bodega ya seleccionados");
      this.deleteItemsData(index);
      return;
    }

    let item = this.comboDataItems.find(x => x.id == $event)
    if (item) {
      this.itemsData[index].itemInventoryId = $event
      this.itemsData[index].unitMeasurement = item.unitMeasurement
      this.itemsData[index].code = item.code
      this.itemsData[index].costItem = item.costItem
      this.itemsData[index].itemName = item.itemName
      this.itemsData[index].currentAmount = item.amount

      if (!this.showAmount) {
        this.itemsData[index].amount = 1
        this.handlerItemsService.updateItems(this.itemsData)
      }
    }
  }

  async addNew(type: string, index: number) {
    let size: number = screen.width > 500 ? 60 : 50;

    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data: { name: type },
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      switch (type) {
        case 'item':
          this.comboDataItems = await this.http.getDataBody(this.urlItemCombo, this.paramsItemsCombo);
          break;
      }
    });
  }

  async valueProvider($event: number) {
    if ($event && $event > 0) {
      this.comboPurchaseOrder = true
      this.providerId = $event
    }
  }

  async valueWarehouse($event: Warehouse) {
    const { id } = $event;
    await this.setWarehouse(id)
    if (this.comboWorkOrder) {
      this.workOrderId = null
    }
    if (!this.editHistoryInventory && this.source == HandlerItemsSource.OUTPUTS) this.initializeItemData()
  }

  async valueTargetWarehouse($event: Warehouse) {
    this.destinationWarehouseId = $event.id;
  }

  async valueWarehouseByItem($event: Warehouse, index: number) {
    let previusWarehouseId = this.itemsData[index].warehouseId
    this.itemsData[index].warehouseId = $event.id
    this.itemsData[index].warehouse = $event.name

    await this.setWarehouse($event.id, index)
    if (this.itemsData[index].itemInventoryId) {
      let item: Item = this.comboItemsByWarehouse[$event.id.toString()].find(x => x.id == this.itemsData[index].itemInventoryId)
      if (item && item.amount >= this.itemsData[index].amount) {
        this.itemsData[index].currentAmount = item.amount
        this.itemsData[index].warehouse = $event.name
      } else {
        await this.setWarehouse(previusWarehouseId, index)
        this.itemsData[index].warehouseId = previusWarehouseId
        this.message.Warning("Advertencia", `Cantidad Insuficiente de ${item.itemName} en Bodega ${$event.name}`)
      }
    }
  }

  async changesComboPurchaseOrder($event: number) {
    this.message.openLoading('Cargando', 'Cargando información')
    if ($event && $event > 0) {
      this.purchaseOrderId = $event
      let res = await this.http.getDataBody<Array<HistoryInventory>>(`${EndpointDictionary.PurchaseOrder.CRUD_PURCHASE_ORDER}/${this.purchaseOrderId}`)
      if (res) {
        this.itemsData = res[0].items
        this.editItems()
      }
    } else {
      this.purchaseOrderId = null
      this.initializeItemData()
    }
    this.message.closeLoading()
  }

  dataComboProvider($event: Array<Provider>) {
    this.comboDataProvider = $event
  }

  dataComboPurchaseOrder($event: PurchaseOrder[]) {
    this.comboPurchaseOrder = $event.length > 1
  }

  async dataComboWarehouse($event: Warehouse[]) {
    this.comboDataWarehouse = $event
  }

  async dataComboTargetWarehouse($event: Warehouse[]) {
    this.comboDataWarehouse = $event
  }

  valueUser($event: number) {
    if ($event && $event > 0) {
      this.userAuthorizeId = $event
    }
  }

  dataComboUser($event: Array<User>) {
    this.comboDataUser = $event
  }

  async changesComboRentalOrder($event: RentalOrder) {
    this.rentalorderId = $event.id
    this.itemsData = []
    for (const element of $event.equipments) {
      this.itemsData.push({
        itemInventoryId: element.equipmentId,
        costItem: element.rentalCost,
        totalCost: element.rentalCost,
        code: element.equipmentCode,
        amount: 1,
        itemName: element.equipmentName
      })
    }

    this.editItems()
    this.handlerItemsService.updateItems(this.itemsData)
  }

  async changesComboWorkOrder($event: number) {
    if ($event && $event > 0) {
      this.workOrderId = $event
    } else {
      this.workOrderId = null
    }
  }

  errorMessage() {
    this.message.Error('Error!', 'Debe completar los campos del formulario')
  }

  handlerAddForm() {
    if (!this.fromPackOff) {
      if (this.itemsData.length == 0 || this.itemsData[this.itemsData.length - 1].itemInventoryId) {
        this.itemsData.push({ itemInventoryId: null, amount: 0 })
        this.reloadItemVersions.push(0)
      }
    } else {
      if (this.itemsData.length == 0 || (this.itemsData[this.itemsData.length - 1].warehouseId && this.itemsData[this.itemsData.length - 1].itemInventoryId)) {
        this.itemsData.push({ warehouseId: null, itemInventoryId: null, amount: 0 })
        this.reloadItemVersions.push(0)
      }
    }
  }

  deleteItemsData(index?: number, deleteById = false, itemInventoryId?: number) {
    if (index === undefined || index < 0) {
      index = this.itemsData.length - 1;
    }

    if (deleteById) {
      index = this.itemsData.findIndex(x => x.itemInventoryId == itemInventoryId)
    }

    if (index >= 0 && index < this.itemsData.length) {
      this.itemsData.splice(index, 1)
      this.reloadItemVersions.splice(index, 1)
    }
    if (this.itemsData.length == 0) {
      this.handlerAddForm()
    }
    this.handlerItemsService.updateItems(this.itemsData)
  }

  incompleteRequiredFields() {
    if (this.addAuthorize && this.addReceptionDate && this.addWarehouse) {
      if (this.userAuthorizeId <= 0 || this.receptionDate == undefined || this.warehouseId <= 0) {
        this.errorMessage()
        return true
      }
    }

    if (this.showTargetWarehouse && this.destinationWarehouseId <= 0) {
      this.message.Error('Error!', 'Debe seleccionar una bodega destino')
      return true
    }

    let itemSaveData = this.itemsData.find(x => x.amount <= 0)
    if (itemSaveData) {
      this.message.Error('Error!', 'La cantidad debe ser mayor a 0')
      return true
    }
    return false
  }

  openDialogFunction() {
    if (!this.openDialog) {
      this.save()
      return
    }
    if (this.incompleteRequiredFields()) {
      return
    }
    let configurationDialog: TableConfiguration = {
      primaryKey: 'id'
    }
    let columnasDialog: TableColumns<InputOrOutputInventory>[] = [
      {
        ID: 'code',
        label: 'Código',
        type: 'text',
        style: { textAlign: 'center', movil: 'no-movil' },
      },
      {
        ID: 'itemName',
        label: 'Item',
        type: 'text',
        style: { textAlign: 'center' },
      }
    ]

    if (this.showAmount) {
      columnasDialog.push({ ID: 'amount', label: 'Cantidad', type: 'number', style: { textAlign: 'center' } });
    }

    if (this.showUnitMeasurement) {
      columnasDialog.push({ ID: 'unitMeasurement', label: 'Unidad', type: 'text', style: { textAlign: 'center', movil: 'no-movil' } });
    }

    columnasDialog.push({ ID: 'costItem', label: 'Costo', type: 'currency', style: { textAlign: 'center' } });

    if (this.fromPackOff) {
      columnasDialog.splice(0, 0, { ID: 'warehouse', label: 'Bodega', type: 'text', style: { textAlign: 'center', movil: 'no-movil' } });
    }

    const data: DataDialog = {
      comment: this.editHistoryInventory?.comment,
      configurationDialog,
      columnasDialog,
      dataTable: JSON.parse(JSON.stringify(this.itemsData)),
      totalCost: this.total,
      titleDialog: this.titleDialog
    }

    const dialogRef = this.dialog.open(DialogDetailsList, { data, width: '80%' });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result[0]) {
        this.save(result)
      }
    });
  }

  save(result?: Array<boolean | string>) {
    if (this.itemsData[0].itemInventoryId > 0) {
      if (this.incompleteRequiredFields()) {
        return
      }
    }

    this.listItemComplete.emit({
      id: this.editHistoryInventory?.id ?? null,
      userId: this.storage.get<number>('userId'),
      items: this.itemsData.length == 1 && !this.itemsData[0].itemInventoryId ? [] : this.itemsData,
      providerId: this.providerId,
      authorize: this.userAuthorizeId,
      requests: this.storage.get<number>('userId'),
      active: 1,
      authorized: this.storage.get<number>('userId') == this.userAuthorizeId ? 1 : 0,
      stateId: this.storage.get<number>('userId') == this.userAuthorizeId ? 2 : 1,
      totalCost: this.total,
      receptionDate: this.addReceptionDate ? this.functionEter.dateDB(this.receptionDate) : null,
      orderId: this.editHistoryInventory?.orderId ?? this.workOrderId ?? null,
      comment: result ? result[1] as string : "",
      purchaseOrderId: this.purchaseOrderId ?? 0,
      warehouseId: this.warehouseId,
      destinationWarehouseId: this.destinationWarehouseId,
      rentalorderId: this.rentalorderId ?? 0
    })
  }

  keyUpAmout(index: number, deleteById = false) {
    if (this.keyUpTimeouts.has(index)) {
      clearTimeout(this.keyUpTimeouts.get(index))
    }
    const timer = setTimeout(() => {
      this.keyUpTimeouts.delete(index)
      let item = this.itemsData[index]
      if (!item) return
      if (item.currentAmount >= item.amount || (!this.addCurrentAmount && this.source !== HandlerItemsSource.OUTPUTS)) {
        this.handlerItemsService.updateItems(this.itemsData)
      } else {
        this.message.Warning("Advertencia", `Cantidad Insuficiente de ${item.itemName}, tiene actualmente ${item.currentAmount} ${item.unitMeasurement}`)
          .then(() => {
            item.amount = item.currentAmount
            this.handlerItemsService.updateItems(this.itemsData)
            if (item.currentAmount == 0) {
              this.deleteItemsData(index, deleteById, item.itemInventoryId)
            }
          })
      }
    }, 500);
    this.keyUpTimeouts.set(index, timer)
  }

  replyRouteNavigate() {
    if (this.replyRoute) this.router.navigate([this.replyRoute])
    this.goBackButton.emit(true)
  }

  print() {
    this.printButton.emit(this.editHistoryInventory?.id)
  }

  suma() {
    this.handlerItemsService.updateItems(this.itemsData);
  }

  private async getComboItems(): Promise<Item[]> {
    this.paramsItemsCombo[0].value = this.warehouseId ?? 0
    this.comboDataItems = await this.http.getDataBody(this.urlItemCombo, this.paramsItemsCombo)
    return this.comboDataItems
  }

  private async setWarehouse(warehouseId: number, i?: number) {
    this.warehouseId = warehouseId
    await this.getComboItems()

    if (warehouseId == null) return

    this.comboItemLength.emit({ length: this.comboDataItems.length, warehouseId: this.warehouseId });

    if (this.fromPackOff && i !== undefined) {
      if (this.itemsData[i].warehouseId && !this.comboItemsByWarehouse[this.itemsData[i].warehouseId.toString()]) {
        this.comboItemsByWarehouse[this.itemsData[i].warehouseId.toString()] = this.comboDataItems
      }
      // Signal the row to clear its item combo selection
      this.reloadItemVersions[i] = (this.reloadItemVersions[i] ?? 0) + 1;
    }
  }

}

interface DataDialog {
  comment: string;
  configurationDialog: TableConfiguration;
  columnasDialog: Array<TableColumns<any>>;
  dataTable: Array<InputOrOutputInventory>;
  totalCost: number;
  titleDialog: string;
}


@Component({
  selector: 'dialog-details-list',
  templateUrl: './dialog-details-list.html',
  standalone: false
})
export class DialogDetailsList {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DataDialog) {
    this.comment = data.comment ?? ""
  }
  public comment: string
}
